<template>
  <div class="d-flex align-items-center justify-content-center">
    <label class="mr-3" for="all">Select all</label>
    <app-input type="checkbox" :list="[{ id: -1 }]" v-model="check" />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";

export default {
  name: "SelectAll",
  mixins: [FormMixin],
  props: {
    all: {
      default: () => [],
    },
  },
  data() {
    return {
      check: false,
    };
  },
  watch: {
    check(val) {
      if (val.includes("-1")) {
        this.$emit("select-all");
      } else this.$emit("un-select-all");
    },
  },
};
</script>
